@if (busquedaActiva) {
<div class="my-search">
  <form [formGroup]="formSearchText" class="tw-flex">
    <nz-input-group>
      <input nz-input type="text" formControlName="searchText" [placeholder]="placeholderSearch" />
    </nz-input-group>
    <button nz-button nzType="primary" type="button" class="new-grid-search-button" (click)="ejecutarBusqueda()"><i class="fal fa-search"></i> Buscar</button>
    <span nzInputSuffix>
      @if (formSearchText.controls.searchText.value) {
      <button type="button" class="tw-mr-3 tw-cursor-pointer" nz-button nzType="link" (click)="formSearchText.controls.searchText.setValue('')" aria-label="Limpiar búsqueda">
        <i class="fal fa-close"></i>
      </button>
      }
      <i class="fal fa-search"></i>
    </span>
  </form>
</div>
}

<div class="my-table" [ngStyle]="styleTable">
  @if (showResults || showCreate) {
  <nz-row class="tw-mb-4" nzJustify="space-between" nzAlign="middle">
    <nz-col>
      @if (showResults) {
      <span>Resultados: ({{ displayData?.length || 0 }})</span>
      }
    </nz-col>
    <nz-col>
      <!-- opcional: botón crear si lo quieres, pero no obliga -->
      @if (showCreate) {
      <button type="button" nz-button nzType="default" (click)="onCreate.emit()" [disabled]="isLoading || !canCrear">
        <i class="fal fa-plus tw-mr-2"></i>
        {{ createLabel }}
      </button>
      }
    </nz-col>
  </nz-row>
  }

  <nz-table
    #basicTable
    [nzData]="displayData"
    [nzLoading]="isLoading"
    [nzFrontPagination]="true"
    [nzPageSize]="15"
    [nzPageSizeOptions]="[5, 15, 20, 50]"
    nzShowSizeChanger
    [nzShowTotal]="totalTemplate"
    (nzQueryParams)="onQueryParams.emit($event)"
  >
    <thead>
      <tr>
        @for (col of normalizedCols; track col) {
        <th [id]="col.field" [style.width.px]="col.widthPx" [nzColumnKey]="col.field" [nzShowSort]="col.sortable" [nzSortFn]="col.sortable ? col.sortFn : null">
          {{ col.headerName }}
        </th>
        }
      </tr>
    </thead>

    <tbody>
      @for (row of basicTable.data; track trackByRow($index, row)) {
      <tr (dblclick)="onSelected.emit(row)">
        @for (col of normalizedCols; track col) {
        <td [style.width.px]="col.widthPx">
          @if (col.enlace ?? false) {
          <a
            rel="noopener noreferrer"
            [class.tw-cursor-pointer]="isLinkEnabled(col, row)"
            [class.download-link]="col.field === '__download'"
            [class.download-link-enabled]="col.field === '__download' && isLinkEnabled(col, row)"
            [class.download-link-disabled]="col.field === '__download' && !isLinkEnabled(col, row)"
            [attr.href]="isLinkEnabled(col, row) && !col.cellClick ? row[col.field] : null"
            [class.tw-pointer-events-none]="!isLinkEnabled(col, row)"
            [class.tw-opacity-40]="!isLinkEnabled(col, row)"
            [attr.aria-disabled]="!isLinkEnabled(col, row)"
            [attr.aria-label]="col.headerName || col.field"
            [attr.title]="col.field === '__download' ? (row?.descargando ? 'Descargando...' : isLinkEnabled(col, row) ? 'Descargar' : 'No disponible') : null"
            [style.cursor]="isLinkEnabled(col, row) ? 'pointer' : 'default'"
            [style.textDecoration]="'none'"
            (click)="handleLinkClick($event, col, row)"
          >
            <span [innerHTML]="renderCell(col, row)"></span>
          </a>
          } @else {
          {{ getCellValue(row, col.field) }}
          }
        </td>
        }
      </tr>
      }
    </tbody>
  </nz-table>
  <ng-template #totalTemplate let-total>Total: {{ total }} elementos</ng-template>
  <div class="new-grid-refresh">
    <button nz-button type="button" aria-label="Actualizar" [disabled]="isLoading" (click)="refrescarTabla()">↻</button>
  </div>
</div>
